import { oneSizeCodesSet } from "~/constants/one-size-codes";
import { Nullable } from "~/types/general.types";

export const checkIsOneSizeProduct = (sizeId?: Nullable<string>): boolean => {
  return typeof sizeId !== "undefined" && sizeId !== null
    ? oneSizeCodesSet.has(sizeId)
    : false;
};
